// src/FeedHub.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// (ไอคอน)
const BuildingLibraryIcon = () => (
  <svg className="h-16 w-16 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" />
  </svg>
);
const ListBulletIcon = () => (
  <svg className="h-16 w-16 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75h12M8.25 12h12M8.25 17.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
  </svg>
);
// (เพิ่มไอคอนใหม่สำหรับกระทรวง)
const BanknotesIcon = () => (
  <svg className="h-16 w-16 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z" />
  </svg>
);

function FeedHub() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (user?.role !== 'admin') {
    navigate('/');
    return null;
  }

  return (
    <div className="container mx-auto p-4 sm:p-6 lg:p-8">
      <button
        onClick={() => navigate('/admin')} // (ปุ่มกลับไปหน้า Admin หลัก)
        className="mb-6 px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700"
      >
        &larr; กลับไปหน้า Admin Panel
      </button>

      <h2 className="text-3xl font-semibold text-gray-800 mb-6 border-b pb-3">
        จัดการ Feed (Scraper)
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        
        {/* (เพิ่ม) 1. จัดการกระทรวง */}
        <Link 
          to="/admin/feeds/ministries" 
          className="block p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-purple-600 group-hover:text-purple-700">
            <BanknotesIcon />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            จัดการกระทรวง
          </h3>
          <p className="text-base text-gray-600">
            (เช่น "กระทรวงการคลัง")
          </p>
        </Link>

        {/* 2. จัดการหน่วยงาน */}
        <Link 
          to="/admin/feeds/agencies" 
          className="block p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-green-600 group-hover:text-green-700">
            <BuildingLibraryIcon />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            จัดการหน่วยงาน
          </h3>
          <p className="text-base text-gray-600">
            (เช่น "กรมศุลกากร")
          </p>
        </Link>
        
        {/* 3. จัดการหัวข้อ/ลิงก์ */}
        <Link 
          to="/admin/feeds/topics" 
          className="block p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-blue-600 group-hover:text-blue-700">
            <ListBulletIcon />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            จัดการหัวข้อ (Topics)
          </h3>
          <p className="text-base text-gray-600">
            (เช่น "ประกาศกรม", "ข่าว")
          </p>
        </Link>

      </div>
    </div>
  );
}

export default FeedHub;